import i18n from '../../i18n';

// Resolve the element in the recorded document, never execute its action.
export function elementAtPoint(player, clientX, clientY) {
  const frame = player?.iframe;
  if (!frame?.contentDocument) return null;
  const rect = frame.getBoundingClientRect();
  if (!rect.width || !rect.height) return null;
  let x = (clientX - rect.left) * frame.clientWidth / rect.width;
  let y = (clientY - rect.top) * frame.clientHeight / rect.height;
  let doc = frame.contentDocument;
  let target = doc.elementFromPoint(x, y);
  while (target?.tagName === 'IFRAME') {
    try {
      const nested = target.contentDocument;
      if (!nested) break;
      const box = target.getBoundingClientRect();
      x -= box.left; y -= box.top; doc = nested;
      target = doc.elementFromPoint(x, y);
    } catch (_) { break; }
  }
  const id = player.getMirror().getId(target);
  return id > 0 ? id : null;
}

export function showGuidance(target, agentName, blockedSelector) {
  if (!target?.isConnected || target.nodeType !== 1 || target.closest(blockedSelector)) return null;
  const box = target.getBoundingClientRect();
  if (!box.width || !box.height) return null;
  const doc = target.ownerDocument;
  const marker = doc.createElement('div');
  marker.className = 'eo-observation eo-support-pointer';
  marker.setAttribute('data-support-private', '');
  marker.setAttribute('role', 'status');
  const label = doc.createElement('span');
  label.textContent = i18n.t('supportChat:liveGuidance.indicatesElement', {
    agent: agentName || i18n.t('supportChat:liveGuidance.defaultAgentName'),
  });
  Object.assign(label.style, { position: 'absolute', left: '0', whiteSpace: 'nowrap', borderRadius: '5px',
    background: '#086452', color: '#fff', padding: '5px 8px', font: 'bold 12px system-ui', boxShadow: '0 2px 8px #0003' });
  marker.appendChild(label);
  Object.assign(marker.style, { position: 'fixed', zIndex: '2147483647', pointerEvents: 'none',
    boxSizing: 'border-box', border: '3px solid #087f68', borderRadius: '8px',
    boxShadow: '0 0 0 4px #42d8ad66', color: '#fff', background: '#087f681a',
    font: 'bold 12px system-ui', textShadow: '0 1px 3px #000', padding: '4px' });
  doc.body.appendChild(marker);
  const location = window.location.href;
  let interval, timeout;
  const clear = () => { clearInterval(interval); clearTimeout(timeout); marker.remove(); };
  const position = () => {
    if (!target.isConnected || document.hidden || location !== window.location.href || target.closest(blockedSelector)) return clear();
    const rect = target.getBoundingClientRect();
    if (!rect.width || !rect.height) return clear();
    label.style.top = rect.top < 35 ? `${rect.height + 8}px` : '-30px';
    Object.assign(marker.style, { left: `${rect.left - 3}px`, top: `${rect.top - 3}px`,
      width: `${rect.width + 6}px`, height: `${rect.height + 6}px` });
  };
  position(); interval = setInterval(position, 100); timeout = setTimeout(clear, 5000);
  return clear;
}
